import Vue from 'vue'
import Vuex from 'vuex'
import { Tokenauthentication } from '../api/patient'
import createVuexAlong from 'vuex-along'
import '../utils/axiosRequest'
import { Message } from 'element-ui'
// import Home from '../views/Home.vue'
import router from '../router/index.js'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    Jumpid: '',
    user: {}, // 用户信息
    usert: {}, //,
    isLogin: false,
    clickIndex: undefined,
    rutset: '', // 课程详情页 记录跳转路径
    scxx: '',
    scxxpf: '课程收藏',
    scxxll: '学习记录',
    height: '',
    resss: '',
    sucaixi: '',
    // 类
    zusc1: 1,
    ybcs: '',
    httpsURL: 'http://123.56.170.62:8888/',
    httpsURL1:'http://123.56.170.62:443/',
    hometz: 0,
    tzzx: '',
    issuser: '',
    //组件切换
    // routerPath:'grxx'
    classXX: [],
    myXX:[]
  },
  mutations: {
    isUploadthetype (state, item) {
      state.issuser = item
    },
    zxxixvt (state, item) {
      state.tzzx = item
    },
    classXX(state, item) {
      state.classXX = item
    },
    myXX(state, item) {
      state.myXX = item
    },
    // routerPath (state, item) {
    //   state.routerPath = item
    // },
    // clickIndex (state, item) {
    //   state.clickIndex = item
    // },
    homres (state, item) {
      state.hometz = item
    },
    // 状态
    Stateofsss (state, item) {
      state.ybcs = item
    },
    // 状态
    Stateofthe1 (state, item) {
      state.zusc1 = item
    },
    sucaixingqi (state, item) {
      state.sucaixi = item
    },
    itemss (state, item) {
      state.resss = item
    },
    height (state, item) {
      state.height = item
    },
    scxxllid (state, item) {
      state.scxxll = item
    },
    // 收藏
    collection (state, item) {
      state.scxxpf = item
    },
    // 素材评价
    scrxi (state, item) {
      state.scxx = item
    },
    subset (state, item) {
      state.rutset = item
    },
    Jumpfordetails (state, item) {
      state.Jumpid = item
    },
    userts (state, item) {
      state.usert = item
    },
    getUser (state, item) {
      state.user = item
    },
    checkToken (state, s) {
      state.isLogin = s
    },
    httpsURL (state, s) {
      state.httpsURL = s
    },
    httpsURL1 (state, s) {
      state.httpsURL1 = s
    }
  },
  actions: {
    // token 验证
    // async  checkToken ({
    //   commit
    // }) {
    //   var token = new FormData()
    //   token.append('token', localStorage.getItem('Token'))
    //   token.append('phone', this.state.user.phone)
    //   await Tokenauthentication(token).then(res => {
    //     if (res.code === 'OK') {
    //       commit('checkToken', true)
    //     } else if (res.code === 'ERR') {
    //       // console.log('111',router)
    //       // if (router.app._route.path == '/personalnav') {
    //       //   router.push({name: 'Home'})
    //       //   Message({
    //       //     showClose: true,
    //       //     message: res.msg,
    //       //     type: 'error'
    //       //   })
    //       // }
    //       commit('getUser', {})
    //       commit('checkToken', false)

    //     }
    //   })
    // },
    // 保存用户信息
    getUser ({ commit }, user) {
      commit('getUser', user)
    }
  },
  modules: {},
  plugins: [createVuexAlong()]
})
